import {
  TOKENS,
  TOKEN_ATTRIBUTES,
} from "@/libs/apis/onboarding/reactQueryCacheKeys";
import { useCollectionData } from "@/src/hooks/useCollectionData";
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { FormattedTokenAttributeRarity } from "./types";
import { makeTokenAttributeRarityApiCall } from "./services";

export const useTokenAttributeRarity = (
  tokenId: string,
  collectionSlug: string,
) => {
  const { collectionData } = useCollectionData(collectionSlug);
  const chainId = collectionData?.chainId;
  const contractAddress = collectionData?.contractAddress;

  const { isLoading, error, data } = useQuery<
    FormattedTokenAttributeRarity,
    AxiosError,
    FormattedTokenAttributeRarity
  >(
    [TOKENS, tokenId, TOKEN_ATTRIBUTES],
    () =>
      makeTokenAttributeRarityApiCall(
        tokenId as string,
        chainId as number,
        contractAddress as string,
      ),
    {
      retry: false,
      enabled: !!chainId && !!contractAddress && !!tokenId,
    },
  );

  return { isLoading, error, data };
};
